export interface AirbnbSpecialConsiderationsParams {
  channel: string
  property: string
  room: string
  locale: string
}

export interface AirbnbSpecialConsiderationsResponse {
  locale: string
  special_considerations: string
}

// Airbnb Supported Locales, verified 2026-09-07:
// https://developer.withairbnb.com/homes/docs/supported-locales
export const airbnbDescriptionLocales = [
  { id: 'az', name: $localize`Azerbaijani` },
  { id: 'id', name: $localize`Indonesian` },
  { id: 'bs', name: $localize`Bosnian` },
  { id: 'ca', name: $localize`Catalan` },
  { id: 'cs', name: $localize`Czech` },
  { id: 'da', name: $localize`Danish` },
  { id: 'de', name: $localize`German` },
  { id: 'et', name: $localize`Estonian` },
  { id: 'en-AU', name: $localize`English (Australia)` },
  { id: 'en-CA', name: $localize`English (Canada)` },
  { id: 'en', name: $localize`English` },
  { id: 'es', name: $localize`Spanish` },
  { id: 'fr', name: $localize`French` },
  { id: 'hr', name: $localize`Croatian` },
  { id: 'xh', name: $localize`Xhosa` },
  { id: 'zu', name: $localize`Zulu` },
  { id: 'is', name: $localize`Icelandic` },
  { id: 'it', name: $localize`Italian` },
  { id: 'sw', name: $localize`Swahili` },
  { id: 'lv', name: $localize`Latvian` },
  { id: 'lt', name: $localize`Lithuanian` },
  { id: 'hu', name: $localize`Hungarian` },
  { id: 'mt', name: $localize`Maltese` },
  { id: 'ms', name: $localize`Malay` },
  { id: 'nl', name: $localize`Dutch` },
  { id: 'no', name: $localize`Norwegian` },
  { id: 'pl', name: $localize`Polish` },
  { id: 'pt', name: $localize`Portuguese` },
  { id: 'ro', name: $localize`Romanian` },
  { id: 'sq', name: $localize`Albanian` },
  { id: 'sk', name: $localize`Slovak` },
  { id: 'sl', name: $localize`Slovenian` },
  { id: 'sr', name: $localize`Serbian` },
  { id: 'fi', name: $localize`Finnish` },
  { id: 'sv', name: $localize`Swedish` },
  { id: 'tl', name: $localize`Tagalog` },
  { id: 'vi', name: $localize`Vietnamese` },
  { id: 'tr', name: $localize`Turkish` },
  { id: 'el', name: $localize`Greek` },
  { id: 'bg', name: $localize`Bulgarian` },
  { id: 'mk', name: $localize`Macedonian` },
  { id: 'ru', name: $localize`Russian` },
  { id: 'uk', name: $localize`Ukrainian` },
  { id: 'ka', name: $localize`Georgian` },
  { id: 'hy', name: $localize`Armenian` },
  { id: 'he', name: $localize`Hebrew` },
  { id: 'ar', name: $localize`Arabic` },
  { id: 'hi', name: $localize`Hindi` },
  { id: 'th', name: $localize`Thai` },
  { id: 'ko', name: $localize`Korean` },
  { id: 'ja', name: $localize`Japanese` },
  { id: 'zh', name: $localize`Chinese (Simplified)` },
  { id: 'zh-TW', name: $localize`Chinese (Traditional)` },
]
